import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

export const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-2 border-black hover:bg-black hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-black mb-4">Datenschutzerklärung</h1>
          <div className="w-24 h-1 bg-gradient-to-r from-black to-[#00CCDD]"></div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8">
          
          <section>
            <h2 className="text-2xl font-bold text-black mb-4">1. Datenschutz auf einen Blick</h2>
            <p className="text-gray-700 leading-relaxed">
              Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Personenbezogene Daten werden vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung behandelt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">2. Verantwortlicher</h2>
            <p className="text-gray-700 leading-relaxed">
              THS Bauprojekte GmbH<br />
              Bornheimer Str. 127<br />
              53119 Bonn<br /><br />
              <strong>Telefon:</strong> 0176 – 59885691<br />
              <strong>E-Mail:</strong> <a href="mailto:info@thsbauprojekte.de" className="text-[#00CCDD] hover:underline">info@thsbauprojekte.de</a><br />
              <strong>Website:</strong> <a href="https://www.ths-bauprojekte.de" className="text-[#00CCDD] hover:underline">www.ths-bauprojekte.de</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">3. Erhebung und Speicherung personenbezogener Daten</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Wir erheben personenbezogene Daten, wenn Sie uns diese freiwillig mitteilen, z. B. durch:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Kontaktaufnahme per E-Mail oder Telefon</li>
              <li>Angebots- oder Auftragsanfragen</li>
              <li>Vertragsabwicklung</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4 mb-2">
              <strong>Erhobene Daten können sein:</strong>
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Name, Adresse</li>
              <li>Telefonnummer</li>
              <li>E-Mail-Adresse</li>
              <li>Rechnungs- und Zahlungsdaten</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">4. Zweck der Datenverarbeitung</h2>
            <p className="text-gray-700 leading-relaxed mb-2">Die Verarbeitung erfolgt zur:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Bearbeitung von Anfragen</li>
              <li>Angebotserstellung</li>
              <li>Vertragsdurchführung</li>
              <li>Rechnungsstellung</li>
              <li>Erfüllung gesetzlicher Pflichten</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">5. Weitergabe von Daten</h2>
            <p className="text-gray-700 leading-relaxed mb-2">Eine Weitergabe Ihrer Daten erfolgt nur, wenn:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>sie zur Vertragserfüllung notwendig ist</li>
              <li>eine gesetzliche Verpflichtung besteht</li>
              <li>Sie ausdrücklich eingewilligt haben</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">6. Speicherdauer</h2>
            <p className="text-gray-700 leading-relaxed">
              Ihre Daten werden nur so lange gespeichert, wie dies für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">7. Ihre Rechte</h2>
            <p className="text-gray-700 leading-relaxed mb-2">Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Auskunft über Ihre gespeicherten Daten</li>
              <li>Berichtigung oder Löschung</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Widerspruch gegen die Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              <strong>Anfragen richten Sie bitte an:</strong> <a href="mailto:info@thsbauprojekte.de" className="text-[#00CCDD] hover:underline">info@thsbauprojekte.de</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">8. SSL-Verschlüsselung</h2>
            <p className="text-gray-700 leading-relaxed">
              Unsere Website nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">9. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};